/**
 * Separates the number from the partition when the partition starts with a
 * digit. "12" + "1-24" ran together as "121-24", which reads as house 121 --
 * exactly when it matters most, since this label is what a map pin and a delete
 * confirmation name. A letter partition needs no separator: "12A" has never
 * been ambiguous, and that is the form the roll is written in.
 *
 * Display only. property_no and partition stay separate columns everywhere
 * they are stored, compared, or exported -- the shapefile keeps `house_no` and
 * `partition` apart on purpose, so nothing downstream has to split this back up.
 *
 * Mirrors label_for() in the backend's services/house_numbering.py and
 * propertyLabel() in the field app's models/field_feature.dart. All three must
 * agree, or the same property reads differently depending on which screen you
 * are looking at.
 */
export const PARTITION_SEPARATOR = "/";

/** How a numbered property reads: "12A", "12/1-24", or "12" unpartitioned.
 *  Empty when there is no number -- an imported outline nobody has surveyed. */
export function propertyLabel(
  propertyNo: string | null | undefined,
  partition: string | null | undefined
): string {
  const n = (propertyNo ?? "").trim();
  if (!n) return "";
  const p = (partition ?? "").trim();
  if (!p) return n;
  return /^[0-9]/.test(p) ? `${n}${PARTITION_SEPARATOR}${p}` : `${n}${p}`;
}
